// src/components/ProductDetail/HotDealInfo.tsx

import { useEffect, useState } from "react"

type Props = {
    sold: number
    progressPercent: number // 0 - 100
    endTime: Date | string  // thời điểm kết thúc deal
}

export default function HotDealInfo({
    sold,
    progressPercent,
    endTime,
}: Props) {

    const calcTimeLeft = () => {
        const end = new Date(endTime).getTime()
        const now = Date.now()
        const diff = Math.max(0, end - now)

        const days = Math.floor(diff / (1000 * 60 * 60 * 24))
        const hours = Math.floor((diff / (1000 * 60 * 60)) % 24)
        const minutes = Math.floor((diff / (1000 * 60)) % 60)
        const seconds = Math.floor((diff / 1000) % 60)

        return { days, hours, minutes, seconds }
    }

    const [time, setTime] = useState(calcTimeLeft())

    useEffect(() => {
        const timer = setInterval(() => {
            setTime(calcTimeLeft())
        }, 1000)
        return () => clearInterval(timer)
    }, [endTime])

    return (
        <div className="styles_hotInfo__9A396">

            {/* LEFT TEXT */}
            <div className="styles_textContainer__1QrRo">
                <span className="styles_text__GLibt">
                    <span>
                        <span className="styles_bold__J7AP_">Ưu đãi mới</span>
                    </span>
                </span>
            </div>

            {/* RIGHT INFO */}
            <div className="styles_rightInfo__bpgar">

                <span className="styles_countBuy__xCs2l">
                    Đã bán {sold}
                </span>

                {/* PROGRESS */}
                <div
                    className="MuiLinearProgress-root MuiLinearProgress-colorPrimary css-1xesb5u MuiLinearProgress-determinate"
                    role="progressbar"
                    aria-valuenow={progressPercent}
                    aria-valuemin={0}
                    aria-valuemax={100}
                    style={{
                        width: "140px",
                        height: "8px",
                        backgroundColor: "#E9E9E9",
                        borderRadius: "0"
                    }}
                >
                    <div
                        className="MuiLinearProgress-bar MuiLinearProgress-barColorPrimary MuiLinearProgress-bar1Determinate"
                        style={{
                            transform: `translateX(-${100 - progressPercent}%)`,
                        }}
                    />
                </div>

                {/* COUNTDOWN */}
                <div className="styles_timeDiscount__lsraI">
                    <div>
                        <span>Còn {time.days} Ngày, </span>
                        <span className="styles_minWidth__jKcwk">
                            {String(time.hours).padStart(2, "0")}
                        </span>
                        <span className="styles_minWidth__jKcwk">:</span>
                        <span className="styles_minWidth__jKcwk">
                            {String(time.minutes).padStart(2, "0")}
                        </span>
                        <span className="styles_minWidth__jKcwk">:</span>
                        <span className="styles_minWidth__jKcwk">
                            {String(time.seconds).padStart(2, "0")}
                        </span>
                    </div>
                </div>

            </div>
        </div>
    )
}
